module.exports = __webpack_public_path__ + "static/media/depart-s.2a6bceb7.jpg";